export default {"src":"/_next/static/media/lobster.c8dc2a8c.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};